import React from 'react';
import { Box } from '@mui/material';
import { Activity } from '../../../../types/activity';
import { CircularAvatarPhoto } from '../../../elements';
import { Typography } from '../../../Typography';

export interface Props {
  activity: Activity
}

const ActivityListItemWrapper: React.FC<Props> = ({
  activity,
}: Props) => (
  <Box display="flex" alignItems="center" marginBottom="15px">

    {activity.userImageUrl

      && <CircularAvatarPhoto innerBorderSize="0px" outerBorderSize="0px" size="50px" avatarImg={activity.userImageUrl} avatarName={activity.userName} />}
    <Box marginLeft="10px" alignItems="center">
      <Typography variant="title" size="0.75rem">{activity.text}</Typography>
      <Typography variant="subtitle" size="0.625rem">{activity.date}</Typography>
    </Box>

  </Box>
);


export { ActivityListItemWrapper as ActivityListItem };
